import { cn } from '@/util/cn'
import { IChannel } from '@giphy/js-types'

import AddIcon from '@/app/icons/add'
import { ClickToShowModal } from '../../modal'
import { CollectionLabel } from '../ui'

type Props = { className?: string; channel: IChannel }

const NewCollectionRow = ({ className, channel }: Props) => {
    const isSubChannel = channel.ancestors.length > 0
    return (
        <ClickToShowModal
            modal={{
                name: 'createCollection',
                channelId: channel.id,
            }}
            className={cn(
                'cursor-pointer rounded-md',
                'striped-background',
                `hover:border-giphyLightCharcoal basis-full`,
                'flex items-center justify-center',
                className
            )}
        >
            <AddIcon className="size-5" />
            <CollectionLabel className="text-2xl" label={`New ${isSubChannel ? 'Sub-' : ''}Collection`} />
        </ClickToShowModal>
    )
}

export default NewCollectionRow
